import styled, { css } from 'styled-components';

const rowBase = css`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  min-width: 0;
  max-width: 100%;
  border: 0;
  margin: 0;
  font: inherit;
  text-align: left;

  .MuiSvgIcon-root {
    font-size: 14px;
    flex-shrink: 0;
  }
`;

/** White pill for the storefront header panel. */
const heroShell = css`
  ${rowBase}
  padding: 6px 12px;
  border-radius: 999px;
  background: #ffffff;
  border: 1px solid rgba(26, 26, 46, 0.08);
  color: #1a1a2e;
`;

export const RatingLine = styled.div.withConfig({
  shouldForwardProp: (prop) => !['$surface', '$interactive'].includes(prop),
})`
  ${({ $surface }) => ($surface === 'hero' ? heroShell : rowBase)}

  ${({ $surface, $interactive }) =>
    $surface === 'hero' &&
    $interactive &&
    `
    cursor: pointer;
    &:hover {
      border-color: rgba(13, 78, 254, 0.35);
    }
  `}
`;

export const RatingMeta = styled.span.withConfig({
  shouldForwardProp: (prop) => prop !== '$surface',
})`
  white-space: nowrap;
  flex-shrink: 0;
  line-height: 1;
  font-size: ${({ $surface }) => ($surface === 'hero' ? '13px' : '0.78rem')};
  color: ${({ $surface }) => ($surface === 'hero' ? '#1a1a2e' : '#5a6478')};
  font-weight: ${({ $surface }) => ($surface === 'hero' ? 600 : 500)};
`;

export const BrandLogo = styled.img.withConfig({
  shouldForwardProp: (prop) => prop !== '$source',
})`
  display: block;
  flex-shrink: 0;
  width: auto;
  height: ${({ $source }) => ($source === 'nky' ? '16px' : '13px')};
`;

export const RatingsStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  min-width: 0;
  max-width: 100%;
  margin-bottom: 2px;
`;
